export default __webpack_public_path__ + "static/media/bg2-section-mobile.1c384654.jpg";